import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-apollo';
import LoadingOverlay from 'react-loading-overlay';
import { map } from 'lodash';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import ReactImageFallback from 'react-image-fallback';
import { Scrollbars } from 'react-custom-scrollbars';
import {
  routeConstants, loaderStyle, staticConstants, capitalizeEveryWord, FALLBACK_ICON,
} from '../../../utils';
import { GET_DUE_BETA_POST } from '../../../graphql-client/queries';

function AnalyticsDuePost(props) {
  const { isHide } = props;
  const { loading, data } = useQuery(GET_DUE_BETA_POST);

  const dataList = data && data.dueBetaPost.data;
  const renderDueBetaPosts = () => {
    if (dataList) {
      return map(dataList, (item) => {
        const artistInfo = item && item.userId;
        return item && (
          <div className="due-posts-card">
            <div className="due-posts-card-user-image">
              <ReactImageFallback
                src={artistInfo.artistImage}
                fallbackImage={FALLBACK_ICON}
                className="image-cover"
                alt="User"
              />
            </div>
            <div className="due-posts-card-user-detail">
              <h2>{capitalizeEveryWord(artistInfo.name)}</h2>
              <h4>{item.offerId.title}</h4>
              <p>{item.offerId.clientName}</p>
              <div className="due-posts-card-user-detail-btn">
                <Button
                  type="button"
                  color="blank"
                >
                  <Link
                    to={`${routeConstants.ADMIN_CAMPAIGN}/${item.offerId._id}/${artistInfo._id}`}
                    target="_blank"
                    className={!item.offerId ? 'pointer-none' : ''}
                  >
                    Campaign timeline
                  </Link>
                </Button>
                <span>
                  <Link
                    to={{
                      pathname: `${routeConstants.OFFER_DETAIL}/${item.offerId._id}`,
                      state: { isFrom: staticConstants.COMPONENT_KEYWORDS.ADMIN_ANALYTICS_PAGE },
                    }}
                    className={!item.offerId ? 'pointer-none' : ''}
                  >
                    See opportunity
                  </Link>
                </span>
              </div>
            </div>
          </div>
        );
      });
    }
    return null;
  };

  return (
    <>
      <LoadingOverlay
        active={loading}
        spinner
        text=""
        className="mainLoader"
        styles={loaderStyle}
      />
      <div className="due-posts">
        <div className="due-posts-content">
          {
            dataList && dataList.length > 0
          && (
          <>
            <h1>Posts due today</h1>
            <div className="due-posts-card-wrapper">
              <Scrollbars
                style={{ width: '100%', height: '100%' }}
                thumbMinSize={30}
              >
                {renderDueBetaPosts()}
              </Scrollbars>
            </div>
          </>
          )
          }
          {
            dataList && dataList.length === 0
              && (
              <div className="empty-box">
                <h3>No Posts due today!</h3>
              </div>
              )
                }
        </div>
        <div className="due-posts-backdrop" onClick={isHide} />
      </div>
    </>
  );
}
AnalyticsDuePost.propTypes = {
  isHide: PropTypes.func.isRequired,
};

export default AnalyticsDuePost;
